import { useEffect, useState } from 'react'

const DEBOUNCE_MS = 300

export function useDebouncedSearch(value: string, delay: number = DEBOUNCE_MS): string {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
